import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateProfile } from '@/api/auth';
import { QueryKeys } from '@/constants/query-keys';

export function useUpdateUserLanguage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (language: string) => updateProfile({ language }),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeys.Profile],
      });
    },
  });
}
